function getQueryParameters () {
  const query = window.location.search
  return parseSearchParams(query)
}

function parseSearchParams (params) {
  if (!params) return {}
  const searchParams = {}
  params.replace(/\?/g, '').split('&').forEach(param => {
    const { 0: key, 1: value } = param.split('=')
    searchParams[decodeURIComponent(key)] = decodeURIComponent(value)
  })
  return searchParams
}

function joinFilterState (params = {}, firstLoad = false) {
  const queryParams = getQueryParameters()

  // ovo bi trebalo preraditi u neko više generično rešenje, možda nekad kasnije
  // edge case kada se ukloni poslednji filter
  // ako je broj propova u params manji od onog u URL-u, znaci da je korisnik uklonio poslednji filter
  // pošto su tarifa i platforma obavezni, možemo da hardkodiramo da uvek treba ukloniti filters objekat
  // firstLoad param nam služi da prepoznamo promenu platforme, inače će na svaku promenu platforma izbaciti sve filtere
  if (Object.keys(params).length <= 1 && !params.filters && !firstLoad) {
    delete queryParams.filters
  }
  return { ...queryParams, ...params }
}

function setQueryParameters (params = {}, firstLoad = false) {
  if (!Object.keys(params).length) return

  const globalState = joinFilterState(params, firstLoad)

  const baseUrl = window.location.origin + window.location.pathname
  const urlParameters = { ...globalState, ...params }
  const newParams = []
  Object.entries(urlParameters).forEach(param => {
    if (param[1] && param[1].length) {
      const encoded = param.map(p => {
        if (Array.isArray(p) && p[0] !== 'platform') {
          return encodeURIComponent(p.join('|')) // filtere iz iste grupe razdvajamo | simbolom
        } else {
          return encodeURIComponent(p)
        }
      })
      newParams.push(encoded.join('='))
    }
  })

  const newUrl = `${baseUrl}?${newParams.join('&')}`
  window.history.pushState({ path: newUrl }, '', newUrl)
}

function clearQueryParameters (exclude = []) {
  const existingParams = getQueryParameters()
  const newQueryParams = {}

  exclude.forEach(e => {
    newQueryParams[e] = existingParams[e]
  })

  setQueryParameters(newQueryParams)
}

export {
  getQueryParameters,
  setQueryParameters,
  clearQueryParameters
}
